import overviewController from "./overview/overview.controller.js";
import segmentController from "./segment/segment.controller.js";
import ecourseController from "./ecourse.controller.js";

import bannerDirective from "./shared/banner/banner.directive.js";
import segmentBarDirective from "./shared/segmentBar/segmentBar.directive.js";
import progressBarDirective from "./shared/progressBar/progressBar.directive.js";

import routerConfig from "./ecourse.route.js";
import './registration/registration.module.js';
import runBlock from "./ecourse.run.js";
import '../components/player/player.module.js';

import {playerAnimation} from './ecourse.animation.js';

import LiveService from './liveService/live.service.js';
import OverlayFactory from './shared/overlays/overlay.factory.js';

angular.module('app.ecourse', ['ui.router', 'app.services', 'app.ecourse.registration', 'app.player'])
  .run(runBlock)
  .config(routerConfig)

  .directive('banner', bannerDirective)
  .directive('segmentBar', segmentBarDirective)
  .directive('progressBar', progressBarDirective)

  .controller('OverviewController', overviewController)
  .controller('EcourseController', ecourseController)
  .controller('SegmentController', segmentController)

  .animation('.hero-animate', playerAnimation)

  .service('LiveService', LiveService)
  .service('OverlayFactory', OverlayFactory);








/** WEBPACK FOOTER **
 ** ./src/app/ecourse/ecourse.module.js
 **/